export default __webpack_public_path__ + "static/media/share-24px.d8a6a993.svg";